'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Created by hoa on 23/03/2018.
 */
define(['app', '$window', '$console', 'accessibleModalHelper', 'accessibilityFocusHelper', 'enhancedEcom', 'siteObj'], function (app, $window, $console, accessibleModalHelper, accessibilityFocusHelper, enhancedEcom, siteObj) {

  var responsiveBasket = function responsiveBasket() {
    var component = {};

    var _config = {
      attrib: {
        skuRemoveID: 'data-remove-sku',
        offerRemoveID: 'data-remove-offer',
        tierRemoveID: 'data-remove-tier',
        isAutoExpanded: 'data-auto-expand',
        freeGiftID: 'data-free-gift-id',
        modalFreeGiftID: 'data-modal-free-gift-id',
        basketFreeGiftID: 'data-basket-free-gift-id',
        basketContext: 'data-basket-context',
        hasQualified: 'data-qualifedgift',
        productID: 'data-product-id',
        productName: 'data-product-name',
        productPrice: 'data-product-price',
        quantity: 'data-product-qty',
        externalSku: 'data-product-externalSku',
        brand: 'data-product-brand',
        fulfilment: 'data-product-fulfilment',
        warehouseStock: 'data-product-warehouse-stock',
        category: 'data-product-category',
        collectionType: 'data-collection-type',
        deliverable: 'data-product-deliverable',
        expiredDiscountCodeEndDate: 'data-expired-discount-code-end-date',
        discountCodeExpired: 'data-discount-code-expired'
      },
      selectors: {
        basketButton: '[data-js-element=responsiveBasket_modalTriggerConditions]',
        selectedFreeProducts: '[data-current-selected]',
        qualifiedFreeGiftModal: '[data-open-qualifiedfreegift-modal]',
        continueToCheckoutButton: '[data-continuetocheckout]',
        selectFreeGiftButton: '[data-selectfreegift-button]',
        freeGiftInfoIcon: '[data-js-element=freeProductSelection_freeGiftInfoIcon]',
        toggleOpen: '[data-js-element=freeProductSelection_toggleOpen]',
        freeProductItem: '[data-product-item]',
        scrollToFreeProductsMessage: '[data-scroll-to-free-gift]',
        basketContext: '[data-basket-context]',
        enhancedEcommerce: '.hasEnhancedEcommerce',
        expiredDiscountCodeEndDate: '[data-expired-discount-code-end-date]'
      },
      classNames: {
        showQualifiedFreeGiftModal: 'responsiveBasket_qualifiedFreeGiftModal-show',
        closeModalClass: 'responsiveBasket_qualifiedFreeGiftModal-close',
        popUpLock: 'js-popup-lock',
        continueToCheckoutButtonButtonClass: 'responsiveBasket_qualifiedFreeGiftModalButton-continueToCheckout',
        toggleOpenClass: 'freeProductSelection-show',
        upsellLink: '.responsiveBasket_upsellAlert a',
        upsellContainer: '.responsiveBasket_upsellAlert'
      }
    };

    var _init = function _init(element, bindFromInit) {
      component.element = element;
      component.freeProductSelections = component.element.querySelectorAll('[data-freeProductSelection]');
      component.qualifiedFreeGiftModal = component.element.querySelector(component.config.selectors.qualifiedFreeGiftModal);
      component.enhancedEcommerce = component.element.querySelector(component.config.selectors.enhancedEcommerce);
      component.discountCodeNotApplied = component.element.querySelector('[data-discountCodeNotApplied]');
      component.discountCodeApplied = component.element.querySelector('[data-discountCodeApplied]');
      component.upsellLink = component.element.querySelector(component.config.classNames.upsellLink);
      if (document.querySelectorAll(component.config.classNames.upsellContainer)) {
        component.addEventListenerToUpsellLink();
      }

      if (siteObj.config.useGa4EnhancedEcom) {

        component.ga4ViewCart();

        var useGa4EnhancedEcomButtons = component.element.querySelectorAll('[data-useGa4EnhancedEcom]');
        Array.from(useGa4EnhancedEcomButtons).map(function (element) {
          return element.addEventListener('click', function (e) {
            trackGa4EnhancedEcommerce(e);
          });
        });
      }

      if (component.enhancedEcommerce) {
        var removeItemButtons = component.element.querySelectorAll('[data-enhanced-ecommerce-remove]');
        var addItemButtons = component.element.querySelectorAll('[data-enhanced-ecommerce-add]');
        var products = component.element.querySelectorAll('.v3ResponsiveBasket_basketItemRow_productDetails');
        if (products) {
          enhancedEcom.basketView(products);
        }
        if (removeItemButtons) {
          Array.from(removeItemButtons).map(function (element) {
            return element.addEventListener('click', function (e) {
              component.trackEnhancedEcommerce(e, true);
            });
          });
        }
        if (addItemButtons) {
          Array.from(addItemButtons).map(function (element) {
            return element.addEventListener('click', function (e) {
              component.trackEnhancedEcommerce(e, false);
            });
          });
        }
      }

      if (siteObj.config.useGa4EnhancedEcom === true) {
        if (component.discountCodeNotApplied) {
          var code = component.discountCodeNotApplied.getAttribute('data-discountCodeNotApplied');
          app.publish('ga4tracking/record/coupon', 'custom_event', 'apply_coupon_fail', code);
        }
      }

      var contextEl = component.element.querySelector(component.config.selectors.basketContext);
      component.context = contextEl && contextEl.getAttribute(component.config.attrib.basketContext);

      component.attachTracking();

      if (siteObj.basketDiscountCode) {
        if (siteObj.discountCodeApplied === 'discount.code.applied') {
          if (siteObj.config.useGa4EnhancedEcom === true) {
            app.publish('ga4tracking/record/coupon', 'custom_event', 'apply_coupon_success', siteObj.basketDiscountCode);
          } else {
            window.dataLayer.push({
              event: 'customEvent',
              eventData: {
                eventCategory: 'referral scheme',
                eventAction: 'redeemed',
                eventLabel: siteObj.basketDiscountCode,
                eventPage: ''
              }
            });
          }
        }
      }

      if (component.freeProductSelections.length) {
        component.initialiseFreeProductDependencies(bindFromInit);
        bindFromInit && component.bindAndAttachListeners();
      }

      component.generateLocalisedDates();
    };

    var _generateLocalisedDates = function _generateLocalisedDates() {
      var endDateAlert = component.element.querySelector(component.config.selectors.expiredDiscountCodeEndDate);
      if (endDateAlert) {
        var endDate = endDateAlert.getAttribute(component.config.attrib.expiredDiscountCodeEndDate);
        var endDateLabel = endDateAlert.getAttribute(component.config.attrib.discountCodeExpired);

        var localisedEndDate = new Date(endDate);

        var formattedDate = localisedEndDate.toLocaleDateString(undefined, { day: 'numeric' });
        var formattedMonth = localisedEndDate.toLocaleDateString(undefined, { month: 'long' });
        var formattedYear = localisedEndDate.toLocaleDateString(undefined, { year: 'numeric' });
        var formattedTime = localisedEndDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' }).split(' ')[0];

        endDateAlert.textContent = endDateLabel + ' ' + formattedDate + ' ' + formattedMonth + ' ' + formattedYear + ' ' + formattedTime;
      }
    };

    var _trackEnhancedEcommerce = function _trackEnhancedEcommerce(e, remove) {
      var externalSku = e.currentTarget.getAttribute(component.config.attrib.externalSku);
      var productID = e.currentTarget.getAttribute(component.config.attrib.productID);
      var productName = e.currentTarget.getAttribute(component.config.attrib.productName);
      var productPrice = e.currentTarget.getAttribute(component.config.attrib.productPrice);
      var quantity = e.currentTarget.getAttribute(component.config.attrib.quantity);
      var brand = e.currentTarget.getAttribute(component.config.attrib.brand);
      var fulfilment = e.currentTarget.getAttribute(component.config.attrib.fulfilment);
      var warehouseStock = e.currentTarget.getAttribute(component.config.attrib.warehouseStock);
      var category = e.currentTarget.getAttribute(component.config.attrib.category);
      var collectionType = e.currentTarget.getAttribute(component.config.attrib.collectionType);
      var deliverable = e.currentTarget.getAttribute(component.config.attrib.deliverable);
      var sku = "";
      if (externalSku) {
        sku = externalSku;
      } else {
        sku = productID;
      }

      if (remove) {
        enhancedEcom.removeFromBasket(productName, sku, productPrice, quantity, brand, fulfilment, warehouseStock, collectionType, category, deliverable);
      } else {
        enhancedEcom.addToBasket(siteObj.currencyType, productName, sku, productPrice, quantity, brand, fulfilment, warehouseStock, collectionType, category, deliverable);
      }
    };

    var getCategoryFromLocalStorage = function getCategoryFromLocalStorage(element, itemId) {
      // First check if the element already has a category value
      var existingCategory = element.getAttribute('data-product-category');

      if (existingCategory && existingCategory.trim() !== '') {
        // If element has a category, use it
        return existingCategory;
      }

      // Find the remove button element
      var removeItemElement = element.parentElement.querySelector('.responsiveBasket_removeItem.hasEnhancedEcommerce') || "";

      // Check if remove button has a category
      if (removeItemElement && removeItemElement.getAttribute) {
        var removeButtonCategory = removeItemElement.getAttribute('data-product-category');

        if (removeButtonCategory && removeButtonCategory.trim() !== '') {
          // If remove button has a category, use it and sync with element
          element.setAttribute('data-product-category', removeButtonCategory);
          return removeButtonCategory;
        }
      }

      // Finally try localStorage as last resort
      var storedItemCategory = localStorage.getItem(itemId) || '';

      if (storedItemCategory && element) {
        // If found in localStorage, sync with both elements
        element.setAttribute('data-product-category', storedItemCategory);
        if (removeItemElement && removeItemElement.setAttribute) {
          removeItemElement.setAttribute('data-product-category', storedItemCategory);
        }
        return storedItemCategory;
      }

      // If all else fails, return empty string
      return "";
    };

    var _ga4GetItems = function _ga4GetItems() {
      var basketItems = document.querySelectorAll('.ga4_item_data');

      var basketData = {
        "event": "view_cart",
        "ecommerce": {
          currency: siteObj.currencyType,
          value: siteObj.basketTotalValueSansCurrency,
          items: []
        }
      };

      if (basketItems !== null && basketItems.length > 0) {
        basketItems.forEach(function (item, index) {
          var itemData = item.dataset;
          var itemId = itemData.productId;

          // Get category from multiple sources
          var category = '';
          var categorySource = 'none';

          // First try direct dataset access (most reliable)
          if (itemData.productCategory) {
            category = itemData.productCategory;
            categorySource = 'dataset';
          }

          // If empty, use our enhanced function that checks multiple sources
          if (!category || category.trim() === '') {
            category = getCategoryFromLocalStorage(item, itemId);
            if (category && category.trim() !== '') {
              categorySource = 'getCategoryFromLocalStorage';
            }
          }

          // If still empty, try one more approach - check parent element for category info
          if (!category || category.trim() === '') {
            var parentLi = item.closest('li');
            if (parentLi) {
              var removeButton = parentLi.querySelector('.responsiveBasket_removeItem.hasEnhancedEcommerce');
              if (removeButton && removeButton.hasAttribute('data-product-category')) {
                category = removeButton.getAttribute('data-product-category');
                categorySource = 'parent-remove-button';
              }
            }
          }

          var basketItemObject = {
            item_id: itemData.productId,
            item_name: itemData.productName,
            item_brand: itemData.productBrand || '', // Fixed typo: prductBrand -> productBrand
            item_price: component.formatPrice(itemData.productPrice),
            index: index,
            item_category: category
          };

          basketData.ecommerce.items.push(basketItemObject);
        });
      }

      return basketData;
    };

    var trackGa4EnhancedEcommerce = function trackGa4EnhancedEcommerce(e) {

      // Get the current element
      var currentElement = e.currentTarget;
      var productId = currentElement.getAttribute(component.config.attrib.productID);
      var productName = currentElement.getAttribute(component.config.attrib.productName);

      // Get the parent element that contains both the current element and the ga4_item_data
      var parentElement = currentElement.closest('li');

      // Try to get category from multiple sources
      var category = '';
      var categorySource = 'none';

      // First try the current element's data attribute
      if (currentElement.hasAttribute('data-product-category')) {
        category = currentElement.getAttribute('data-product-category');
        categorySource = 'current-element';
      }

      // If empty, try to find the ga4_item_data element and get its category
      if (!category && parentElement) {
        var dataElement = parentElement.querySelector('.ga4_item_data');
        if (dataElement) {
          if (dataElement.hasAttribute('data-product-category')) {
            category = dataElement.getAttribute('data-product-category');
            categorySource = 'ga4-item-data';
          }
        }
      }

      // If still empty, try to find the remove button and get its category
      if (!category && parentElement) {
        var removeButton = parentElement.querySelector('.responsiveBasket_removeItem.hasEnhancedEcommerce');
        if (removeButton) {
          if (removeButton.hasAttribute('data-product-category')) {
            category = removeButton.getAttribute('data-product-category');
            categorySource = 'remove-button';
          }
        }
      }

      // Create the data object with the best category we could find
      var itemsObjectArray = [{
        'item_name': currentElement.getAttribute(component.config.attrib.productName).toString().replace(/&#039;|'/g, ""),
        'item_id': currentElement.getAttribute(component.config.attrib.productID).toString(),
        'price': parseFloat(currentElement.getAttribute(component.config.attrib.productPrice).substring(1)),
        'item_brand': currentElement.getAttribute(component.config.attrib.brand),
        'quantity': currentElement.getAttribute(component.config.attrib.quantity),
        'item_category': category
      }];

      // Push to dataLayer
      app.publish('ga4tracking/record', 'ecom_event', 'remove_from_cart', siteObj.currencyType, itemsObjectArray);
    };

    var _bindRemove = function _bindRemove() {
      var removeItemButtons = component.element.querySelectorAll('[data-js-element=responsiveBasket_removeItem]');
      if (!removeItemButtons.length) {
        return;
      }
      Array.from(removeItemButtons).map(function (element) {
        return element.addEventListener('click', component.removeItem, false);
      });
    };

    var _removeItem = function _removeItem(e) {
      e.preventDefault();
      var skuRemoveID = e.currentTarget.getAttribute(component.config.attrib.skuRemoveID);
      var offerRemoveID = e.currentTarget.getAttribute(component.config.attrib.offerRemoveID);
      var tierRemoveID = e.currentTarget.getAttribute(component.config.attrib.tierRemoveID);
      var freeGiftId = component.element.querySelector('[data-gift-id="' + skuRemoveID + offerRemoveID + tierRemoveID + '"]');
      var onReload = true;
      var isComplex = freeGiftId.classList.contains('freeProductSelection_itemProductBlock_complex');

      component.freeProduct.removeUniqueItem(skuRemoveID, offerRemoveID, tierRemoveID, freeGiftId, onReload, isComplex);
      app.publish('ga4tracking/record', 'ecom_event', 'remove_from_cart', siteObj.currencyType, itemsObjectArray);
    };

    var _addEventListenerToUpsellLink = function _addEventListenerToUpsellLink() {
      if (component.upsellLink) {
        component.upsellLink.addEventListener('click', component.pushToDataLayer);
      }
      component.upsellContainer = component.element.querySelector(component.config.classNames.upsellContainer);
      if (component.upsellContainer) {
        app.publish('tracking/record', 'viewed', 'upsell alert', 'upsell alert link viewed: ' + component.upsellContainer.innerHTML);
      }
    };

    var _pushToDataLayer = function _pushToDataLayer(e) {
      component.upsellContainer = component.element.querySelector(component.config.classNames.upsellContainer);
      app.publish('tracking/record', 'clicked', 'upsell alert', 'upsell alert link clicked: ' + component.upsellContainer.innerHTML);
    };

    var _ga4ViewCart = function _ga4ViewCart() {
      var dataItems = component.ga4GetItems();
      app.publish('record/general', dataItems);
    };
    var _sanatiseText = function _sanatiseText(text) {};

    var _formatPrice = function _formatPrice(price) {
      price = price.replace(/[^0-9.]/g, '');
      price.trim();
      return parseFloat(price).toFixed(2);
    };

    var _attachTracking = function _attachTracking() {
      if (!component.context) {
        return false;
      }

      component.startTime = new Date().getTime();
      $window.addEventListener('beforeunload', component.trackTimeSpent);

      return true;
    };

    var _removeVerificationOnCheckout = function _removeVerificationOnCheckout(e) {
      app.publish(component.config.channels.removeVerificationCookie);
    };

    var _attachListeners = function _attachListeners() {
      var basketButtons = component.element.querySelectorAll(component.config.selectors.basketButton);
      var continueToCheckoutButton = component.element.querySelector(component.config.selectors.continueToCheckoutButton);
      var selectFreeGiftButton = component.element.querySelector(component.config.selectors.selectFreeGiftButton);
      var infoIcon = component.element.querySelectorAll(component.config.selectors.freeGiftInfoIcon);
      var toggleEvent = component.element.querySelectorAll(component.config.selectors.toggleOpen);
      var freeProductItem = component.element.querySelectorAll(component.config.selectors.freeProductItem);
      var scrollToFreeProductsMessage = component.element.querySelectorAll(component.config.selectors.scrollToFreeProductsMessage);

      component.qualifiedFreeGiftModal.addEventListener('click', component.modalClose, false);
      Array.from(basketButtons).map(function (el) {
        return el.addEventListener('click', component.modalTriggerConditions);
      });
      continueToCheckoutButton.addEventListener('click', component.continueToCheckout);
      selectFreeGiftButton.addEventListener('click', component.modalScrollToOffer);
      Array.from(toggleEvent).map(function (el) {
        return el.addEventListener('click', component.clickCounter);
      });
      Array.from(freeProductItem).map(function (el) {
        return el.addEventListener('click', component.clickCounter);
      });
      Array.from(scrollToFreeProductsMessage).map(function (el) {
        return el.addEventListener('click', component.discountMessageScrollToOffer);
      });

      if (!infoIcon.length) {
        return;
      }
      Array.from(infoIcon).map(function (el) {
        return el.addEventListener('click', component.clickCounter);
      });
    };

    var _clickCounter = function _clickCounter() {
      component.clickCount++;
    };

    var _modalTriggerConditions = function _modalTriggerConditions(e) {
      if (component.freeProductSelections[0]) {
        var hasQualified = component.freeProductSelections[0].getAttribute(component.config.attrib.hasQualified);
        if (hasQualified === 'false') return;
      }

      var selections = component.element.querySelectorAll(component.config.selectors.selectedFreeProducts);
      var arr = Array.from(selections).map(function (el) {
        return parseInt(el.innerHTML);
      });
      var currentSelectionCount = arr.reduce(function (accumulator, currentValue) {
        return accumulator + currentValue;
      }, 0);

      var isAutoExpanded = Array.from(component.freeProductSelections).map(function (el) {
        return el.getAttribute(component.config.attrib.isAutoExpanded);
      });
      var conditions = false;

      if (isAutoExpanded[0] === 'true' || component.clickCount === 0) {
        conditions = true;
      }

      if (component.clickCount > 0) {
        conditions = false;
      }

      if (currentSelectionCount === 0 && conditions && !component.hasAcknowledgedFreeGift) {
        e.preventDefault();
        component.showModal();
      } else {
        app.publish('tracking/record', 'responsiveBasket_qualifiedFreeGiftModal', 'Clicked to go straight to checkout');
      }
    };

    var _showModal = function _showModal() {
      component.prevScrollTop = $window.pageYOffset;

      component.hasAcknowledgedFreeGift = true;
      var openModal = component.qualifiedFreeGiftModal;

      openModal.classList.add(component.config.classNames.showQualifiedFreeGiftModal);
      document.documentElement.classList.add(component.config.classNames.popUpLock);
      document.body.style.top = -component.prevScrollTop + 'px';

      component.accessibleModalHelper = new accessibleModalHelper(document.querySelector('.responsiveBasket_qualifiedFreeGiftModal'), function () {
        return component.hideModal('ESCAPE');
      }, document.querySelector('.responsiveBasket_qualifiedFreeGiftModalTitle'));

      app.publish('tracking/record', 'responsiveBasket_qualifiedFreeGiftModal', 'Modal Shown');
    };

    var _hideModal = function _hideModal(element) {
      var underlay = component.qualifiedFreeGiftModal;
      var closeModalButton = (typeof element === 'undefined' ? 'undefined' : _typeof(element)) === 'object' ? element.classList.contains(component.config.classNames.closeModalClass) : false;

      underlay.classList.remove(component.config.classNames.showQualifiedFreeGiftModal);
      document.documentElement.classList.remove(component.config.classNames.popUpLock);
      document.body.style.top = '';
      app.element.scrollTo(component.prevScrollTop);

      component.accessibleModalHelper && component.accessibleModalHelper.close();

      if (element === underlay) {
        app.publish('tracking/record', 'responsiveBasket_qualifiedFreeGiftModal', 'Clicked on the Modal Underlay');
      }

      if (closeModalButton) {
        app.publish('tracking/record', 'responsiveBasket_qualifiedFreeGiftModal', 'Clicked on X to Close Modal');
      }

      if (element === 'ESCAPE') {
        app.publish('tracking/record', 'athenaBasket_qualifiedFreeGiftModal', 'Pressed ESCAPE key to Close Modal');
      }
    };

    var _modalClose = function _modalClose(e) {
      e.preventDefault();

      if (e.target.classList.contains(component.config.classNames.showQualifiedFreeGiftModal) || e.target.classList.contains(component.config.classNames.closeModalClass)) {
        component.hideModal(e.target);
      }
    };

    var _continueToCheckout = function _continueToCheckout(e) {
      $window.location = "/checkoutStart.account";
      app.publish('tracking/record', 'responsiveBasket_qualifiedFreeGiftModal', 'Clicked to Checkout in modal');
    };

    var _modalScrollToOffer = function _modalScrollToOffer(e) {
      component.hideModal(e.target);

      component.scrollToFreeGift();

      app.publish('tracking/record', 'responsiveBasket_qualifiedFreeGiftModal', 'Clicked to Select Free Gift in modal');
    };

    var _discountMessageScrollToOffer = function _discountMessageScrollToOffer(e) {
      var discountMessageOfferId = e.target.getAttribute(component.config.attrib.basketFreeGiftID);

      component.scrollToFreeGift(discountMessageOfferId);

      app.publish('tracking/record', 'responsiveBasket_discountAlert', 'Clicked to Select Free Gift in alert');
    };

    var _scrollToFreeGift = function _scrollToFreeGift(id) {
      component.hasAcknowledgedFreeGift = true;
      var freeGiftComponent = component.element.querySelector('[data-free-gift-id="' + id + '"]') || component.element.querySelector('[data-qualifedGift=true]');
      var freeGiftComponentTitle = freeGiftComponent.querySelector(component.config.selectors.toggleOpen);

      if (!freeGiftComponent) return $console.warn('ResponsiveBasket: cannot find [data-free-gift-id="' + id + '"] or [data-freeProductSelection].');

      accessibilityFocusHelper.focus(freeGiftComponentTitle);

      freeGiftComponent.classList.add(component.config.classNames.toggleOpenClass);
      app.element.scrollTo(freeGiftComponent, 200);
    };
    var _trackTimeSpent = function _trackTimeSpent() {
      var totalTime = new Date().getTime() - component.startTime;
      app.publish('columbo/track', 'responsiveBasket_' + component.context, 'timing', 'time', totalTime);
    };

    var _initialiseFreeProductDependencies = function _initialiseFreeProductDependencies(bindFromInit) {
      require(['freeProductTiers'], function (freeProductTiers) {
        component.freeProduct = freeProductTiers();

        require(['freeProductSelection'], function (freeProductSelection) {
          Array.from(component.freeProductSelections).map(function (el) {
            freeProductSelection().init(el);
          });

          !bindFromInit && component.bindAndAttachListeners();
        });
      });
    };

    var _bindAndAttachListeners = function _bindAndAttachListeners() {
      if (component.qualifiedFreeGiftModal) {
        component.hasAcknowledgedFreeGift = false;
        component.clickCount = 0;
        component.attachListeners();
      }

      component.bindRemove();
    };

    component.config = _config;
    component.init = _init;
    component.ga4GetItems = _ga4GetItems;
    component.generateLocalisedDates = _generateLocalisedDates;
    component.bindRemove = _bindRemove;
    component.removeItem = _removeItem;
    component.attachTracking = _attachTracking;
    component.attachListeners = _attachListeners;
    component.clickCounter = _clickCounter;
    component.modalTriggerConditions = _modalTriggerConditions;
    component.showModal = _showModal;
    component.hideModal = _hideModal;
    component.modalClose = _modalClose;
    component.continueToCheckout = _continueToCheckout;
    component.modalScrollToOffer = _modalScrollToOffer;
    component.discountMessageScrollToOffer = _discountMessageScrollToOffer;
    component.scrollToFreeGift = _scrollToFreeGift;
    component.trackTimeSpent = _trackTimeSpent;
    component.initialiseFreeProductDependencies = _initialiseFreeProductDependencies;
    component.bindAndAttachListeners = _bindAndAttachListeners;
    component.trackEnhancedEcommerce = _trackEnhancedEcommerce;
    component.addEventListenerToUpsellLink = _addEventListenerToUpsellLink;
    component.pushToDataLayer = _pushToDataLayer;
    component.removeVerificationOnCheckout = _removeVerificationOnCheckout;
    component.ga4ViewCart = _ga4ViewCart;
    component.formatPrice = _formatPrice;
    component.sanatiseText = _sanatiseText;

    return component;
  };
  return responsiveBasket;
});
//# sourceMappingURL=responsiveBasket.js.map
